/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Production {

    import fld = WorkOrderItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class WorkOrderItemsEditor extends _Ext.MFGTransItemGridEditor<WorkOrderItemsRow> {



        protected getColumnsKey() { return "Production.WorkOrderItems"; }
        protected getDialogType() { return WorkOrderItemsDialog; }
        protected getLocalTextPrefix() { return WorkOrderItemsRow.localTextPrefix; }
        protected form: WorkOrderItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt;
        }
        // #region Variables 
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
       // public ExchangeRate: number;
        public DeptId: number; 
        public TotalItems: number;
        public isUpdate: number;
        public canUpdate: number;
        public DismantlingType: number;


        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            //   this.slickGrid.setOptions({ forceFitColumns: true, showFooterRow: true });
        }

        private Master;
        public setEditValue(source: DismantlingRow, property) {
            //   super.setOwnerEntity(source);
            this.Master = source;
            super.setEditValue(source, property);
        }
        setData(selectedrow: WorkOrderItemsRow, count: number) {
            var pieces = selectedrow.Pieces;

            var pieceperbags = Math.floor(pieces / count);//5 / 3
            var deptid = parseInt((this.parentDialog as WorkOrderDialog).form.DepartmentId.value);

            for (var i = 0; i < count; i++) {

                var bagno = FormatHelper.GetFormats("Bag");
                var newbom = [];
                var bomdetails = selectedrow.BOMDetails; 
                for (var j = 0; j < bomdetails.length; j++) {
                    var oldbom = bomdetails[j];
                    var bom: WorkOrderBOMRow = {
                        BagNo: bagno,
                        BomProductId: oldbom.BomProductId,
                        AttributeId: oldbom.AttributeId,
                        CompanyId: oldbom.CompanyId,
                        FinancialYearId: oldbom.FinancialYearId,
                        Line_No: oldbom.Line_No,
                        Pieces: oldbom.Pieces,
                        Weight: oldbom.Weight,
                        ProductId: oldbom.ProductId,
                        PureWeight: oldbom.PureWeight,
                        Purity: oldbom.Purity,
                        RefTransBomId: oldbom.RefTransBomId,
                        RefTransId: oldbom.RefTransId,
                        RefTransItemId: oldbom.RefTransItemId,
                        RefVoucherId: oldbom.RefVoucherId,
                        IsCustomerItem: oldbom.IsCustomerItem
                    };
                    newbom.push(bom);
                }
                var value = selectedrow;
                var item: WorkOrderItemsRow = {
                    ProductId: value.ProductId,
                    ProductCode: value.ProductCode,
                    AttributeId: value.AttributeId,
                    Line_No: value.Line_No,
                    BagNo: bagno,
                    SubBagNo: 0,
                    DepartmentId: deptid,
                    Pieces: pieceperbags,
                    Parts: value.Parts,
                    EmployeeId: 0,
                    Weight: (value.Weight / value.Pieces) * pieceperbags ,
                    OtherPieces: (value.OtherPieces / value.Pieces) * pieceperbags,
                    OtherWeight: (value.OtherWeight / value.Pieces) *pieceperbags,
                    StonePieces: (value.StonePieces / value.Pieces) *pieceperbags,
                    StoneWeight: (value.StoneWeight / value.Pieces)* pieceperbags,
                    NetWeight: (value.NetWeight / value.Pieces)*pieceperbags,
                    DiamondPieces: (value.DiamondPieces / value.Pieces) *pieceperbags,
                    DiamondWeight: (value.DiamondWeight / value.Pieces)* pieceperbags,
                    RefTransId: value.RefTransId,
                    RefTransItemId: value.RefTransItemId,
                    RefVoucherId: value.RefVoucherId,
                    DeliveryDate: value.DeliveryDate == undefined ? "1/1/2021 9:00:00.2492948 AM" : value.DeliveryDate,
                    POSCustomerId: value.POSCustomerId,
                    LedgerName: value.LedgerName,
                    RefVoucherNo: value.RefVoucherNo,
                    Attribute: value.Attribute,
                    Purity: value.Purity,
                    PureWeight: value.PureWeight,
                    BOMDetails: newbom
                };
                item[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(item);



            }

            if ((pieceperbags * count) < pieces) {

                var bagno = FormatHelper.GetFormats("Bag");
                var newbom = [];
                var bomdetails = selectedrow.BOMDetails;
                for (var j = 0; j < bomdetails.length; j++) {
                    var oldbom = bomdetails[j];
                    var bom: WorkOrderBOMRow = {
                        BagNo: bagno,

                        BomProductId: oldbom.BomProductId,
                        AttributeId: oldbom.AttributeId,
                        CompanyId: oldbom.CompanyId,
                        FinancialYearId: oldbom.FinancialYearId,
                        Line_No: oldbom.Line_No,
                        Pieces: oldbom.Pieces,
                        Weight: oldbom.Weight,
                        ProductId: oldbom.ProductId,
                        PureWeight: oldbom.PureWeight,
                        Purity: oldbom.Purity,
                        RefTransBomId: oldbom.RefTransBomId,
                        RefTransId: oldbom.RefTransId,
                        RefTransItemId: oldbom.RefTransItemId,
                        RefVoucherId: oldbom.RefVoucherId,
                        IsCustomerItem: oldbom.IsCustomerItem
                    };
                    newbom.push(bom);
                }
                var value = selectedrow;
                var pcs = pieces - (pieceperbags * count);
                var item: WorkOrderItemsRow = {
                    ProductId: value.ProductId,
                    ProductCode: value.ProductCode,
                    AttributeId: value.AttributeId,
                    Line_No: value.Line_No,
                    BagNo: bagno,
                    SubBagNo: 0,
                    DepartmentId: deptid,
                    Pieces: pcs ,
                    Parts: value.Parts,
                    EmployeeId: 0,
                    Weight: (value.Weight / value.Pieces) * pcs,
                    OtherPieces: (value.OtherPieces / value.Pieces) * pcs,
                    OtherWeight: (value.OtherWeight / value.Pieces) * pcs,
                    StonePieces: (value.StonePieces / value.Pieces) *pcs,
                    StoneWeight: (value.StoneWeight / value.Pieces) * pcs,
                    NetWeight: (value.NetWeight / value.Pieces) * pcs,
                    DiamondPieces: (value.DiamondPieces / value.Pieces) * pcs,
                    DiamondWeight: (value.DiamondWeight / value.Pieces) * pcs,
                    RefTransId: value.RefTransId,
                    RefTransItemId: value.RefTransItemId,
                    RefVoucherId: value.RefVoucherId,
                    DeliveryDate: value.DeliveryDate == undefined ? "1/1/2021 9:00:00.2492948 AM" : value.DeliveryDate,
                    POSCustomerId: value.POSCustomerId,
                    LedgerName: value.LedgerName,
                    RefVoucherNo: value.RefVoucherNo,
                    Attribute: value.Attribute,
                    Purity: value.Purity,
                    PureWeight: value.PureWeight,
                    BOMDetails: newbom
                };
                item[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(item);
            }
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();


                if (target.hasClass('delete-row')) {

                    //TODO: Validate for TransItemID in RefTransItemID in Stock
                    Q.confirm('Are you sure want to Delete? ', () => {
                        var id = this.id(item);
                        this.view.deleteItem(id);
                        this.element.trigger('dialogclose');

                    });

                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            this.view.refresh();

        }
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var Employee = Q.first(columns, x => x.field === fld.EmployeeId);
            Employee.referencedFields = [fld.EmployeeId];
            Employee.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.EmployeeId, Master.EmployeeMasterRow.getLookup(), this);

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value = text;



            // *** Set Department ***
            if (field === fld.EmployeeId && value > 0) {
                var deptid = (this.parentDialog as WorkOrderDialog).form.DepartmentId.value;
                var employeebydepartment = Master.EmployeeDetailsRow.getLookup().items.filter(x => x.DepartmentId == parseInt(deptid) && x.EmployeeId == value);
                if (employeebydepartment.length == 0) {
                    q.alert('', 'Employee not in Department Selected', true, 999);
                    item[field] = 0;
                } else {
                    item[field] = value;
                }

            }

            this.view.updateItem(id, item);
            //this.view.bind('dialogclose', () => {

            //    this.element.trigger('dialogclose');

            //});
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }



        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            return buttons;
        }

    }
}